export default {
  namespaced: true,
  state: {
    floorOptions: ['Franco', 'Franco arenoso', 'Franco Limoso'],
    currentFloor: '',
  },
  actions: {
    setCurrentFloor(context, value) {
      context.commit('setCurrentFloor', value);
    },
    clearAll(context) {
      context.commit('clearAll');
    },
  },
  mutations: {
    setCurrentFloor(state, value) {
      state.currentFloor = value;
    },
    clearAll(state) {
      state.floorOptions = ['Franco', 'Franco arenoso', 'Franco Limoso'];
      state.currentFloor = '';
    },
  },
};
